import { useEffect, useState } from 'react';
import { Pagination } from 'types/api';
import { Wallet } from 'types/wallet';
import useWalletApi from './useWalletApi';

export interface UseCoinListProps {
    page?: number;
    size?: number;
    symbol?: string;
    keyword?: string;
    merchantId?: number | string;
    chart?: boolean;
}

const useCoinList = (payload: UseCoinListProps) => {
    const [data, setData] = useState<Wallet[]>([]);
    const [paging, setPaging] = useState<Pagination | null>(null);
    const { qGetFunding, qGetFundingData, qPaginationFunding } = useWalletApi({ ...payload });

    useEffect(() => {
        if (qGetFundingData) {
            setData(qGetFundingData);
        }
    }, [qGetFundingData]);

    useEffect(() => {
        if (qPaginationFunding) {
            setPaging(qPaginationFunding);
        }
    }, [qPaginationFunding]);

    return {
        ...qGetFunding,
        data,
        paging
    };
};

export default useCoinList;
